import { z } from 'zod';

export type ShoppingCartInfoBoxEventType =
  | 'shoppingCartInfoBoxShown'
  | 'shoppingCartInfoBoxLearnMore'
  | 'shoppingCartInfoBoxDismissed'
  | 'shoppingCartInfoBoxRemindLater';

// Shared payload schema for all Shopping Cart Info Box events
const ShoppingCartInfoBoxPayloadSchema = z.object({
  vendor_id: z.string(),
  timestamp: z.string(),
});

export type ShoppingCartInfoBoxEventTypePayloadMap = {
  shoppingCartInfoBoxShown: z.infer<typeof ShoppingCartInfoBoxPayloadSchema>;
  shoppingCartInfoBoxLearnMore: z.infer<typeof ShoppingCartInfoBoxPayloadSchema>;
  shoppingCartInfoBoxDismissed: z.infer<typeof ShoppingCartInfoBoxPayloadSchema>;
  shoppingCartInfoBoxRemindLater: z.infer<typeof ShoppingCartInfoBoxPayloadSchema>;
};

export const ShoppingCartInfoBoxEventSchemaMap = {
  shoppingCartInfoBoxShown: ShoppingCartInfoBoxPayloadSchema,
  shoppingCartInfoBoxLearnMore: ShoppingCartInfoBoxPayloadSchema,
  shoppingCartInfoBoxDismissed: ShoppingCartInfoBoxPayloadSchema,
  shoppingCartInfoBoxRemindLater: ShoppingCartInfoBoxPayloadSchema,
};
